import React, { useMemo, useState } from 'react';
import clsx from 'clsx';

import { useStyles } from './style';
import { SupplierComparePlans } from '../SupplierComparePlans';
import { YourPlan } from '../YourPlan';
import { UpgradePlan } from '../UpgradePlan';
import { useMeQuery } from '../../../../api/user';
import { UpgradePlanSummary } from '../UpgradePlanSummary';
import { useRouteMatch } from 'react-router-dom';

export type PlanTypes = 'free' | 'unlimited' | 'enterprise' | 'pro_lite' | 'trial';

export const CurrentPlan: React.FC = () => {
  const classes = useStyles();
  const [step, setStep] = useState(0);
  const [billedYearly, setBillYearly] = useState(true);
  const [newPlan, setNewPlan] = useState<PlanTypes>('unlimited');

  const { data: user } = useMeQuery();
  const matchPlansRoot = useRouteMatch({ path: '/account/billing/plans', exact: true });

  const isUnlimitedPlan = useMemo(() => {
    return user?.subscription_type === 'unlimited' && user?.trial_days_left === null;
  }, [user]);

  const isFreePlan = useMemo(() => {
    return user?.subscription_type === 'free';
  }, [user]);

  const isEnterprisePlan = useMemo(() => {
    return user?.subscription_type === 'enterprise';
  }, [user]);

  const isProLitePlan = useMemo(() => {
    return user?.subscription_type === 'pro_lite';
  }, [user]);

  const isTrialPlan = useMemo(() => {
    return user?.subscription_type === 'unlimited' && user?.trial_days_left !== null;
  }, [user]);

  const yourPlan = useMemo(() => {
    if(isFreePlan) {
      return 'free';
    }

    if(isEnterprisePlan) {
      return 'enterprise';
    }

    if(isTrialPlan) {
      return 'trial';
    }

    if(isProLitePlan) {
      return 'pro_lite';
    }

    return 'unlimited';
  }, [isUnlimitedPlan, isFreePlan, isEnterprisePlan, isTrialPlan, isProLitePlan]);

  const onUpgradePlanClick = () => {
    setStep(1);
  };

  return <div className={clsx(classes.root)}>
    {step === 0 && <YourPlan upgradePlan={onUpgradePlanClick} currentUser={user} currentPlan={yourPlan} />}
    {step === 1 && <UpgradePlan
                      continueToPayment={() => setStep(2)}
                      backStep={() => setStep(0)}
                      setBillYearly={setBillYearly}
                      setNewPlan={setNewPlan}
                      isYearly={billedYearly}
                      currentPlan={yourPlan} />}
    {step === 2 && <UpgradePlanSummary backStep={() => setStep(1)} isYearly={billedYearly} newPlan={newPlan} currentPlan={yourPlan} />}
    {step !== 2 && matchPlansRoot && <SupplierComparePlans currentStep={step} upgradePlan={onUpgradePlanClick} currentPlan={yourPlan} />}
  </div>
};
